import { useMemo } from "react";

const hiddenOffset = 14;

// Y effects
const getVisibleHeightProps = ({ top, bottom, height }) => {
  if (top || bottom) return { height, y: 0 };
  return { height };
};

const getHiddenHeightProps = ({ top, bottom, height }) => {
  if (top || bottom)
    return { height: 0, y: top ? -hiddenOffset : hiddenOffset };
  return { height };
};

// X effects
const getVisibleWidthProps = ({ left, right, width }) => {
  if (left || right)
    return {
      width,
      x: 0,
    };
  return { width };
};

const getHiddenWidthProps = ({ left, right, width }) => {
  if (left || right)
    return {
      width: 0,
      whiteSpace: "nowrap",
      overflow: "hidden",
      x: left ? -hiddenOffset : hiddenOffset,
    };
  return { width };
};

const useAnimationStyles = ({ top, bottom, right, left, height, width }) => {
  const visible = useMemo(
    () => ({
      opacity: 1,
      ...getVisibleWidthProps({ left, right, width }),
      ...getVisibleHeightProps({ top, bottom, height }),
    }),
    [bottom, height, left, right, top, width]
  );

  const hidden = useMemo(
    () => ({
      opacity: 0,
      ...getHiddenWidthProps({ left, right, width }),
      ...getHiddenHeightProps({ top, bottom, height }),
      transition: {
        type: "tween",
        ease: "backIn",
      },
    }),
    [top, bottom, left, right, height, width]
  );

  return { visible, hidden };
};

export default useAnimationStyles;
